import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { concatMap, delay } from 'rxjs/operators';
import { Action } from 'redux';
import { push } from 'connected-react-router';
import { CancelPendingTakedownSuccess } from '../action-creators';
import { CANCEL_PENDING_TAKEDOWN_SUCCESS } from '../actions';
import { GetCatalog } from '@webapp/store/catalog/action-creators';

export const redirectAfterTakedownCancelEpic = (action$: Observable<Action>) =>
  action$.pipe(
    ofType<Action, CancelPendingTakedownSuccess>(
      CANCEL_PENDING_TAKEDOWN_SUCCESS
    ),
    delay(2000),
    concatMap(() => {
      return [new GetCatalog(), push('/catalog')];
    })
  );
